import React, { useCallback, useEffect } from 'react';
import { SessionStepProps, SessionStaticProps } from './SessionFlowBase';
import styled from 'styled-components';
import { AccountType } from '../../api';
import useSession from '../Util/useSession';
import { useUpdateSession } from './useUpdateSession';
import { TSession } from './Sessions';
import SelectSingleAccount from '../Util/SelectSingleAccount';
import { Account } from '../../services/references';
interface Props extends SessionStepProps {}

const SessionSettings: React.FunctionComponent<Props> & SessionStaticProps = ({ sessionid, setNextEnabled }) => {
  const { session } = useSession(sessionid);
  const [updateSession] = useUpdateSession();

  useEffect(() => {
    setNextEnabled(true);
  }, [setNextEnabled]);

  const onChangeLabelAccount = useCallback(
    (account: Pick<Account, 'id'> | undefined) => {
      updateSession({ labelAccountId: account?.id || null }, session);
    },
    [session, updateSession]
  );

  return (
    <CenterContainer>
      <Container>
        <Wrapper>
          <Label>Label company</Label>
          <Divider />
          <Value style={{ padding: 9 }}>
            <SelectSingleAccount
              value={session?.labelAccount || undefined}
              types={[AccountType.Labelling]}
              onChange={onChangeLabelAccount}
            />
          </Value>
        </Wrapper>
      </Container>
    </CenterContainer>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 500px;
`;

const Label = styled.div`
  font-size: 18px;
  font-weight: 500;
  display: flex;
  align-items: center;
  width: 45%;
`;

const Divider = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
`;

const Value = styled.div`
  justify-items: left;
  width: 45%;
  text-align: left;
`;

const CenterContainer = styled.div`
  display: table-cell;
  height: calc(100vh - 350px);
  text-align: center;
  vertical-align: middle;
  width: 100%;
`;

const Container = styled.div`
  width: 500px;
  margin: auto;
`;

SessionSettings.isComplete = (session: TSession) => {
  return true;
};
export default SessionSettings;
